import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

// FastAPI 422 returns an array of {msg} objects; never render that raw in JSX.
export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : "")).filter(Boolean).join(" ") || "Please check your input.";
  if (detail && typeof detail.msg === "string") return detail.msg;
  return "Something went wrong. Please try again.";
}

// Stream an AI draft over SSE. Calls onDelta for each token chunk.
export async function streamGenerate({ taskSlug, fieldKey, prompt, model, onDelta }) {
  const res = await fetch(`${API}/ai/generate`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ task_slug: taskSlug, field_key: fieldKey, prompt, model }),
  });
  if (!res.ok || !res.body) throw new Error("The AI is unavailable right now. Try again in a moment.");
  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let buffer = "";
  while (true) {
    const { done, value } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });
    const parts = buffer.split("\n\n");
    buffer = parts.pop();
    for (const part of parts) {
      const line = part.trim();
      if (!line.startsWith("data:")) continue;
      const payload = JSON.parse(line.slice(5).trim());
      if (payload.delta) onDelta(payload.delta);
      if (payload.error) throw new Error(payload.error);
      if (payload.done) return;
    }
  }
}
